module.exports = __webpack_public_path__ + "img/7_167.c93ea936.png";